import { render, staticRenderFns } from "./cleanTotal.vue?vue&type=template&id=19cf6168&scoped=true&"
import script from "./cleanTotal.vue?vue&type=script&lang=js&"
export * from "./cleanTotal.vue?vue&type=script&lang=js&"
import style0 from "./cleanTotal.vue?vue&type=style&index=0&id=19cf6168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cf6168",
  null
  
)

export default component.exports